import React from 'react';
import loadable from '@loadable/component';
import { Loading } from 'components';
import { FormattedMessage } from 'react-intl';

import { Message as MessageIcon } from '@mui/icons-material';

import { ROUTES_PATH_COLLECTIONS_LIST, ROUTES_PATH_COLLECTIONS_MEDIAFILE_LIST } from 'routes';

const CollectionsList = loadable(
	() => import('./components/Collections/CollectionsList/CollectionsList'),
	{
		fallback: <Loading size={50} />,
	}
);
const CollectionsMediaFileList = loadable(
	() => import('./components/CollectionsMediaFile/MediafileList/MediafileList'),
	{
		fallback: <Loading size={50} />,
	}
);

export const CollectionsRoutes = [
	{
		path: ROUTES_PATH_COLLECTIONS_LIST,
		sidebarName: <FormattedMessage id="pages.Collections.Routes.Collections" />,
		sidebarIcon: MessageIcon,
		component: CollectionsList,
		noBreadcrumbs: false,
		children: [
			// TODO - Need new page for Active Collection
			{
				path: ROUTES_PATH_COLLECTIONS_MEDIAFILE_LIST,
				showCollection: true,
				component: CollectionsMediaFileList,
				noBreadcrumbs: false,
				// requiredUserLevel: { $gte: 40 },
			},
		],
	},
];
// export default CollectionsRoutes;
let adminRoutesByPath = {};
const setRoutesByPath = (routes = []) => {
	routes.forEach((route) => {
		adminRoutesByPath[route.path] = route;
		if (route.children && route.children.length > 0) {
			setRoutesByPath(route.children);
		}
	});
};
setRoutesByPath(CollectionsRoutes);

export { adminRoutesByPath };

export default CollectionsRoutes;
